import React from 'react';
import { Zap, Award, Shield, ThumbsUp, Clock, Users } from 'lucide-react';
import { motion } from 'framer-motion';

export default function WhyUsSection() {
  const reasons = [
    {
      icon: Zap,
      title: 'Lightning Fast',
      description: 'Rapid response to all drainage emergencies',
      color: 'from-slate-700 to-slate-900'
    },
    {
      icon: Award,
      title: 'Expert Team',
      description: 'Certified professionals with years of experience',
      color: 'from-slate-600 to-slate-800'
    },
    {
      icon: ThumbsUp,
      title: 'Quality Guaranteed',
      description: 'We stand behind every job we complete',
      color: 'from-slate-600 to-slate-800'
    },
    {
      icon: Clock,
      title: '24/7 Available',
      description: 'Round-the-clock service when you need it',
      color: 'from-slate-700 to-slate-900'
    },
    {
      icon: Users,
      title: 'Customer First',
      description: 'Your satisfaction is our top priority',
      color: 'from-slate-600 to-slate-800'
    }
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white mb-6">
            <span className="text-sm text-slate-600 font-medium">Why Choose Us</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-slate-900 mb-6 leading-tight">
            Why Perfect Panda
            <span className="block font-bold">Repairs?</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Excellence in every aspect of drainage service
          </p>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1, duration: 0.4 }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="group bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all relative overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${reason.color} opacity-0 group-hover:opacity-5 transition-opacity`} />
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${reason.color} flex items-center justify-center mb-6 relative z-10`}>
                <reason.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 relative z-10">{reason.title}</h3>
              <p className="text-slate-600 relative z-10">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}